import type { FaireProductEntity } from "../../entity_types/product";

export const p_7jq8a5bqka: FaireProductEntity = {
  token: "p_7jq8a5bqka",
  type: "product",
  name: "Orange Squeeze",
  brandToken: "b_2ncsmapy03",
  brandName: "Olipop",
  imageUrl:
    "https://cdn.faire.com/fastly/f7d374da9148d05044a6380b6d5fb5eb5c4f0205415814cb0f0aab7d6dbae5f8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7847be77d957d2c7453e1a57e03b6e80b512357ca2975ae268757766458da0ac.png",
    "https://cdn.faire.com/fastly/9d3864d5ff5c67f21511fe4f13cd0047d62c5f3ed731d41aaec7c5cc4a005281.png",
    "https://cdn.faire.com/fastly/706aaecdba4689f99fda55e07699cfc11e6ff7fcbd37f01032775a16a9986e20.png",
    "https://cdn.faire.com/fastly/cfab05be088f349e6da1b89b2cfe07f34c15a78265ed93265880d107bc8b943c.png",
  ],
  priceDollars: 28.99,
  description:
    "Our Orange Squeeze reinvents orange soda with a citrusy, vitamin C rich blend of natural ingredients. Clementine and mandarin juices collide with a hint of lemon to produce a bright twist on the nostalgic classic.\n\nWholesale cost offers landed cost of $2.42 per unit, which provides a 40% gross margin to the retailer at $3.99 MSRP.",
  tags: [],
  msrpDollars: 57.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T17:24:08.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
